module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_oslo_viken_neg.b192a60c.svg";